<template>
  <div class="section-other-features">
    <div class="section-header">
      <div class="section-header-highlight title-letter-spacing">
        {{ getWordings.applicationSectionOtherSubtitle }}
      </div>
      <div class="section-header-text">{{ getWordings.applicationSectionOtherTitle }}</div>
    </div>
    <div class="intro">
      {{ getWordings.applicationSectionOtherDescription }}
    </div>
    <div class="other-feature-list">
      <OtherFeatureCardView
        v-for="idx in 6"
        :key="idx"
        :image="require(`@/assets/icons/other_feature_icon_f${idx}.svg`)"
        :title="getWordings[`applicationSectionOtherF${idx}Title`]"
        :description="getWordings[`applicationSectionOtherF${idx}Description`]"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import LinkButton from "@/components/controls/LinkButton.vue";
import OtherFeatureCardView from "@/components/parts/OtherFeatureCardView.vue";

@Component({
  components: {
    LinkButton,
    OtherFeatureCardView
  },
  inject: ["routes"]
})
export default class SectionOtherFeatures extends Vue {
  @Getter("text/getWordings") getWordings!: any;
}
</script>

<style lang="scss" scoped>
.section-other-features {
  @include size(100%, auto);
  @include layoutPadding();
  @extend %centerContent;
  flex-direction: column;
  padding-top: 100px;
  padding-bottom: 100px;

  @include mq(m) {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .intro {
    @include fz(l);
    color: $gs4;
    padding: 60px 200px;
    text-align: center;
    @include mq(l) {
      @include fz(m);
      padding: 20px 0px 40px;
    }
  }

  .other-feature-list {
    @include flex(space-between, flex-start);
    row-gap: 75px;
    border-radius: 15px;
    background-color: $gs1;
    border-radius: 15px;
    border: 1px solid $gs7;
    padding: 60px;
    @include mq(m) {
      @include flex(center, center);
      padding: 40px 0px 40px;
      row-gap: 40px;
    }
  }
}
</style>
